/**
 * Discovery context (read model), pure display helpers for search results.
 * No I/O. Kept inside Discovery (read models import nothing from other
 * modules, 04-architecture.md §2), so the money format is intentionally a
 * small local copy rather than a cross-context dependency on Catalog.
 */

import { RATING_BUCKETS } from "./searchParams";

/** "450 m" under 1 km, otherwise "1.2 km" (one decimal). */
export function formatDistance(meters: number): string {
  if (!Number.isFinite(meters) || meters < 0) return "";
  if (meters < 1000) return `${Math.round(meters)} m`;
  return `${(meters / 1000).toFixed(1)} km`;
}

/** "from $30" / "from $30.50", the cheapest service price (H12). */
export function formatFromPrice(minPriceCents: number | null): string | null {
  if (minPriceCents === null) return null;
  const dollars = minPriceCents / 100;
  const hasCents = minPriceCents % 100 !== 0;
  const money = dollars.toLocaleString("en-US", {
    minimumFractionDigits: hasCents ? 2 : 0,
    maximumFractionDigits: 2,
  });
  return `From $${money}`;
}

/** "4★ & up" for a rating filter bucket. */
export function ratingBucketLabel(minRating: number): string {
  return `${minRating}★ & up`;
}

/** The selectable rating buckets, top to bottom, for the filter UI. */
export const RATING_FILTER_OPTIONS = [...RATING_BUCKETS]
  .sort((a, b) => b - a)
  .map((value) => ({ value, label: ratingBucketLabel(value) }));
